import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { setColor } from "../../../../../assets/styles/styles";
import FilterIcon from "../../../../../assets/images/icons/Web_Sprite_Icon_Filter.png";
import EditIcon from "../../../../../assets/images/icons/Web_Sprite_Icon_Edit_Grey.png";

const ClientTagFilter = ({
    clientTags,
    selectedClientTag,
    setSelectedClientTag,
    isClientTagDropdownOpen,
    setIsClientTagDropdownOpen,
}) => {
    const dropdownRef = useRef(null);

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsClientTagDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setIsClientTagDropdownOpen]);

    const handleFilterClick = () => {
        if (clientTags?.length > 1) {
            setIsClientTagDropdownOpen(!isClientTagDropdownOpen);
        }
    };

    return (
        <FilterContainer onClick={handleFilterClick}>
            <Filter mobileWidth={"100%"} style={{ position: "relative" }} ref={dropdownRef}>
                {clientTags?.length > 1 && (
                    <ImageContainer src={FilterIcon} width={"16px"} height={"16px"} padding={"2.235px 0px"} />
                )}

                <AnalyticsText
                    fontSize="18px"
                    fontWeight="600"
                    highlight={isClientTagDropdownOpen}
                    style={{ flex: 1, textAlign: "center" }}
                >
                    {selectedClientTag}
                </AnalyticsText>

                {clientTags?.length > 1 && (
                    <ImageContainer src={EditIcon} width={"16px"} height={"16px"} padding={"2.235px 0px"} />
                )}

                {isClientTagDropdownOpen && (
                    <Dropdown>
                        {clientTags?.map((tag, index) => (
                            <DropdownItem
                                key={tag.tag}
                                selected={selectedClientTag === tag.tag}
                                isLast={index === clientTags.length - 1}
                                onClick={() => {
                                    setSelectedClientTag(tag.tag);
                                    setIsClientTagDropdownOpen(false);
                                }}
                            >
                                {tag.tag}
                            </DropdownItem>
                        ))}
                    </Dropdown>
                )}
            </Filter>
        </FilterContainer>
    );
};

export default ClientTagFilter;

const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;
    }
`;

const FilterDropdownWrapper = styled.div`
    position: relative;
    display: inline-block;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Filter = styled.div`
    display: flex;
    width: ${(props) => (props.width ? props.width : "auto")};
    padding: 10px 16px;
    align-items: center;
    gap: 16px;
    border-radius: 77px;
    border: ${(props) =>
        props.isFlagOpen
            ? "2px solid var(--Purple-Secondary, #9D75F5)"
            : "1px solid var(--purple-secondary-30, rgba(157, 117, 245, 0.3))"};
    &:hover {
        background-color: rgba(157, 117, 245, 0.1);
    }

    @media (max-width: 768px) {
        width: ${(props) => (props.mobileWidth ? props.mobileWidth : "auto")};
    }
`;
const ImageContainer = styled.img`
    display: flex;
    width: ${(props) => (props.width ? props.width : "14px")};
    height: ${(props) => (props.height ? props.height : "14px")};
    padding: ${(props) => (props.padding ? props.padding : "1px 1px")};
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transform: ${(props) => {
        if (props.isChevron && props.isFlagOpen) return "rotate(90deg)";
        if (props.isChevron) return "rotate(-90deg)";
        return "none";
    }};
    transition: transform 0.2s;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-width: 172px;
    min-width: 100px;
    padding: 14px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    gap: 5px;
    border-radius: 10px;
    border: 1px solid var(--white-white-20, rgba(255, 255, 255, 0.2));
    background: #110e21;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
    z-index: 1000;

    @media (max-width: 768px) {
        width: 100vw;
        min-width: unset;
        padding: 14px 0;
        border-radius: 0 0 10px 10px;
    }
`;

const DropdownItem = styled.div`
    display: flex;
    padding: 6px 10px;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    border-radius: ${(props) => (props.selected ? "82px" : "0px")};
    background: ${(props) => (props.selected ? `${setColor.pinkButtonBgGradient}` : "transparent")};
    color: ${(props) => (props.selected ? `${setColor.hightlight}` : `${setColor.inputText}`)};
    cursor: pointer;
    transition:
        background 0.2s,
        color 0.2s;

    &:hover {
        background: ${setColor.iconColor3};
        color: ${setColor.inputBgColor};
    }
`;
const AnalyticsText = styled.p`
    color: ${(props) => (props.highlight ? "#9D75F5" : props.color || "var(--Text-Primary, #fbfcff)")};
    font-family: "Barlow";
    font-size: ${(props) => props.fontSize || "16px"};
    font-style: normal;
    font-weight: ${(props) => props.fontWeight || "400"};
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0.5px;

    span {
        color: var(--Banners-Yellow, #ffe664);
    }
`;
